/**
 * Badge.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { CLOUDFRONT_URL } from '../../utils';

import { BadgeContainer, BadgeName, BadgeDescription, BadgeImage } from './Badge.styles';


/**
 * A component to display a singular badge
 */
export default class Badge extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    imgHeight: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    imgWidth: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      data,
      className,
      imgHeight,
      imgWidth,
      style,
    } = this.props;

    return (
      <BadgeContainer style={ style } className={ className } >
        <BadgeImage
          src={ data.image_url || `${CLOUDFRONT_URL}/badges/qh_badge_locked_square.png` }
          height={ imgHeight }
          width={ imgWidth }
          alt={ `Image for badge: ${data.name}` }
        />
        <BadgeName>
          {data.name}
        </BadgeName>
        <BadgeDescription>
          {data.description}
        </BadgeDescription>
      </BadgeContainer>
    );
  }
}
